import { Button, HStack, VStack } from '@/components/sgBootstrapReactWrapper';
import type { PersonsRolesResponse } from '@/model/Person';
import { isDefined } from '@/utils/assertions';
import { formatCountryName } from '@/utils/country';
import { formatOnlyDate } from '@/utils/date';
import { FormattedMessage, useIntl } from 'react-intl';
import { RiskBadge } from './RiskBadge';

type PartiesDrawerHeaderProps = {
  personsRolesData: PersonsRolesResponse;
  onClose?: () => void;
};
const RolesDrawerHeader = ({ personsRolesData, onClose }: PartiesDrawerHeaderProps) => {
  const { locale } = useIntl();

  return (
    <VStack gap="16px" padding="24px" className="border-bottom">
      <HStack className="justify-content-between gap-2 mb-3">
        <VStack>
          <HStack gap="8px">
            <span data-e2e="role-drawer-fullName" className="display-4">
              {personsRolesData.fullName}
            </span>
            <RiskBadge risk={personsRolesData.risk} />
          </HStack>

          <span data-e2e="role-drawer-person-number">
            <FormattedMessage
              id="roles.drawer.header.number"
              values={{ number: personsRolesData.personKey }}
            />
          </span>
        </VStack>

        <Button
          size="sm"
          purpose="flat"
          onClick={onClose}
          className="p-8px"
          data-e2e="instrument-drawer-close"
        >
          <em className="icon icon-lg text-primary">close</em>
        </Button>
      </HStack>

      <div className="grid gx-16 gy-0 ">
        <VStack className="g-col-4">
          <span className="text-secondary">
            <FormattedMessage id="roles.drawer.header.name" />
          </span>
          <span data-e2e="role-drawer-name">{personsRolesData.birthName}</span>
        </VStack>

        <VStack className="g-col-4">
          <span className="text-secondary">
            <FormattedMessage id="roles.drawer.header.Birthday" />
          </span>
          <span data-e2e="role-drawer-birthday">
            {isDefined(personsRolesData.birthDate)
              ? formatOnlyDate(new Date(personsRolesData.birthDate))
              : '-'}
          </span>
        </VStack>

        <VStack className="g-col-4">
          <span className="text-secondary">
            <FormattedMessage id="roles.drawer.header.Country" />
          </span>
          <span data-e2e="role-drawer-country">
            {isDefined(personsRolesData.residenceCountryCode)
              ? formatCountryName(personsRolesData.residenceCountryCode, locale)
              : null}
          </span>
        </VStack>
      </div>
    </VStack>
  );
};

export default RolesDrawerHeader;
